import { render, staticRenderFns } from "./WorkFloEventPrompt.vue?vue&type=template&id=f49035f8&"
import script from "./WorkFloEventPrompt.vue?vue&type=script&lang=js&"
export * from "./WorkFloEventPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports